import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Stack,
} from '@mui/material';
import moment from 'moment';
import { Form, useTranslate, required } from 'react-admin';
import { GrayDateInputWithUpperLabel } from './inputs/GrayDateInputWithUpperLabel';
import { getMinimumNextDate } from '../../../utils/timeGranularityUtils';

export type PlanRenewalFormValues = {
  plannedRenewalDate: string;
};

export const PlanRenewalModal = (props: {
  open: boolean;
  onClose: () => void;
  onBack?: () => void;
  onSubmit: (values: PlanRenewalFormValues) => Promise<void>;
  dateFieldSource?: string;
  dateFieldLabel: string;
  dateFieldHelperText?: string;
  defaultPlannedRenewalDate?: string | null;
  title: string;
}) => {

  const translate = useTranslate();
  const source = props.dateFieldSource ?? 'plannedRenewalDate';

  const defaultDate = props.defaultPlannedRenewalDate ? moment(props.defaultPlannedRenewalDate) : null;
  const defaultValues = {
    [source]: defaultDate?.isValid() ? defaultDate.format('YYYY-MM-DD') : '',
  };

  const handleSubmit = async (values: Record<string, unknown>) => {

    await props.onSubmit({
      plannedRenewalDate: values[source] as string,
    });

  };
  return (
    <Dialog open={props.open} onClose={props.onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{translate(props.title)}</DialogTitle>
      <DialogContent>
        <Form
          id="plan-renewal-form"
          key={props.open ? String(props.defaultPlannedRenewalDate) : 'closed'}
          defaultValues={defaultValues}
          onSubmit={handleSubmit}
        >
          <Stack spacing={2} sx={{ mt: 3 }}>
            <GrayDateInputWithUpperLabel
              source={source}
              label={props.dateFieldLabel}
              validate={required()}
              helperText={props.dateFieldHelperText}
              inputProps={{ min: getMinimumNextDate() }}
              FormHelperTextProps={{
                sx: {
                  margin: 0,
                  marginLeft: 0,
                },
              }}
            />
          </Stack>
        </Form>
      </DialogContent>
      <DialogActions>
        {props.onBack && (
          <Button onClick={props.onBack}>{translate('ra.action.back')}</Button>
        )}
        <Button onClick={props.onClose}>{translate('ra.action.cancel')}</Button>
        <Button type="submit" form="plan-renewal-form" variant="contained">
          {translate('ra.action.confirm')}
        </Button>
      </DialogActions>
    </Dialog>
  );

};
